// extracted by mini-css-extract-plugin
export default {"photoPost":"UserPhotoPost_photoPost__L4FRW","file":"UserPhotoPost_file__p81td","preview":"UserPhotoPost_preview__H9I2U"};